// src/components/common/NotificationModal.jsx
import React, { useEffect } from 'react';
import { FiCheckCircle, FiAlertCircle, FiInfo } from "react-icons/fi";

const NotificationModal = ({ show, onClose, message, type = 'success', autoClose = 3000 }) => {
    if (!show) return null;

    useEffect(() => {
        const timer = setTimeout(onClose, autoClose);
        return () => clearTimeout(timer);
    }, [show, onClose, autoClose]);

    const styles = {
        success: {
            bg: "bg-green-600/90",
            border: "border-green-500",
            icon: <FiCheckCircle className="text-white text-2xl mr-3" />
        },
        error: {
            bg: "bg-red-600/90",
            border: "border-red-500",
            icon: <FiAlertCircle className="text-white text-2xl mr-3" />
        },
        info: {
            bg: "bg-blue-600/90",
            border: "border-blue-500",
            icon: <FiInfo className="text-white text-2xl mr-3" />
        }
    };

    const current = styles[type] || styles.info;

    return (
        <div
            className={`
                fixed bottom-6 right-6 w-auto max-w-sm rounded-xl shadow-2xl z-[9999]
                p-4 border text-white backdrop-blur-md
                transform transition-all duration-300 animate-slideUp
                flex items-start gap-3
                ${current.bg} ${current.border}
            `}
        >
            {/* Ícone */}
            {current.icon}

            {/* Texto */}
            <div className="flex-1">
                <p className="text-base font-semibold leading-tight">
                    {type === "success" && "Sucesso!"}
                    {type === "error" && "Erro!"}
                    {type === "info" && "Informação"}
                </p>

                <p className="text-sm opacity-90 mt-1">
                    {message}
                </p>
            </div>

            {/* Botão de fechar */}
            <button
                onClick={onClose}
                className="ml-3 px-2 py-1 text-lg font-bold rounded-lg hover:bg-white/20 transition"
            >
                &times;
            </button>

            {/* Animação personalizada */}
            <style>{`
                @keyframes slideUp {
                    from { transform: translateY(20px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
                .animate-slideUp {
                    animation: slideUp 0.35s ease-out;
                }
            `}</style>
        </div>
    );
};

export default NotificationModal;
